import { render, staticRenderFns } from "./recovery_password_email_page.vue?vue&type=template&id=02c7e7e8&"
import script from "./recovery_password_email_page.vue?vue&type=script&lang=js&"
export * from "./recovery_password_email_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports